import Vue from 'vue';
import {mapActions} from "vuex";
import ChainList from './gui/chain-list';
import controller from "./controller";

export default {
    name: 'KinematicsFeature',

    components: {
        ChainList
    },

    data() {
        return {
            chainListBus: new Vue()
        }
    },

    created: function () {
        controller.registerFeature(this);
    },

    methods: {
        ...mapActions('kinematics', {
            populateChains: 'populateChains'
        }),

        populate(data) {
            this.chainListBus.$emit("hideAll");
            this.populateChains(data);
        },

        showChainList() {
            this.chainListBus.$emit("show");
        }
    },
};
